import { useMutation } from '@tanstack/react-query';
import { postApiOrdersByEncryptedOrderIdDiscountCode } from 'api/generated/sdk.gen';
import { useAppState } from 'lib/app-state';

/**
 * Applies a discount code to the order. The backend matches it against event
 * vouchers first, then promo-code basket rules, and returns the repriced order,
 * which replaces the one in app state.
 */
export const useApplyDiscountCode = () => {
  const {
    setEventData
  } = useAppState();
  return useMutation({
    mutationFn: ({
      encryptedOrderId,
      code
    }: {
      encryptedOrderId: string;
      code: string;
    }) => postApiOrdersByEncryptedOrderIdDiscountCode({
      path: {
        encryptedOrderId
      },
      body: {
        code
      }
    }),
    onSuccess: (data: any) => {
      if (data.status === 200 && data.data) {
        setEventData(current => ({
          ...current,
          order: data.data
        }));
      }
    }
  });
};